export default __webpack_public_path__ + "static/media/catago-screenshot-01.4d5045ee.png";